import { Selection } from 'src/projects/types/Selection';
import { updatedLocationState } from 'src/common/updatedLocationState.ts';

export const convertSelection = (item: Selection & { locationState?: unknown }): Selection => {
    if (item.version === '1') {
        return item;
    }

    const {
        searchQuery,
        locationState = undefined,
        ...rest
    } = item;

    const searchParams = new URLSearchParams(searchQuery);
    if (item.locationState !== undefined) {
        updatedLocationState(searchParams, item.locationState);
    }

    return {
        ...rest,
        searchQuery: searchParams.toString(),
    };
};
